module.exports = __webpack_public_path__ + "9de13430a6c9bd8072620dd0c1f97554.svg";